import '../../styles/web-components/inventory-level.scss';
import { INVENTORY_LEVEL_PLACEHOLDER } from '../constants/inventory.constants';
const INVENTORY_PLACEHOLDER_PATTERN = new RegExp(INVENTORY_LEVEL_PLACEHOLDER.replace(/[{}]/g, '\\$&'), 'g');
const template = `
  <div class="inventory-level__container hidden"></div>
`;
class InventoryLevel extends HTMLElement {
    static get observedAttributes() {
        return ['display', 'level', 'inventory-quantity', 'is-final-sale'];
    }
    constructor() {
        super();
    }
    el;
    connectedCallback() {
        this.innerHTML = template;
        this.el = this.querySelector('.inventory-level__container');
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.el || oldValue === newValue)
            return;
        switch (name) {
            case 'display':
                this.updateDisplay(newValue);
                break;
            case 'level':
                this.updateLevel(newValue);
                break;
            case 'inventory-quantity':
            case 'is-final-sale':
                if (this.getAttribute('level')) {
                    this.updateLevel(this.getAttribute('level'));
                }
                break;
            default:
                break;
        }
    }
    updateDisplay(val) {
        if (val === 'show') {
            this.el.classList.remove('hidden');
        }
        else {
            this.el.classList.add('hidden');
        }
    }
    updateLevel(level) {
        if (!level) {
            this.el.innerHTML = '';
        }
        else {
            const textClassNames = [
                'inventory-level__text',
                level === 'lowStock' && this.getAttribute('is-final-sale') === 'true'
                    ? 'inventory-level__text--final-sale-low-stock'
                    : '',
            ]
                .filter(Boolean)
                .join(' ');
            this.el.innerHTML = `<span class="inventory-level__indicator inventory-level__indicator--${level}" aria-hidden="true"></span><span class="${textClassNames}">${this.getInventoryLevelText(level)}</span>`;
        }
    }
    getInventoryLevelText(level) {
        const localeTemplate = window.productUi?.inventoryLevels?.[level] ?? '';
        const rawQuantity = this.getAttribute('inventory-quantity');
        const parsedQuantity = rawQuantity === null || rawQuantity === ''
            ? undefined
            : Number(rawQuantity);
        const inventoryQuantity = Number.isNaN(parsedQuantity)
            ? undefined
            : parsedQuantity;
        const quantityString = inventoryQuantity === undefined ? '' : String(inventoryQuantity);
        return localeTemplate.replace(INVENTORY_PLACEHOLDER_PATTERN, quantityString);
    }
}
if (!window.customElements.get("inventory-level")) {
    customElements.define("inventory-level", InventoryLevel);
}
